import { ComparisonProducts } from '@/features/comparison/comparison-content/comparison-products/comparison-products';
import { ComparisonProperties } from '@/features/comparison/comparison-content/comparison-properties/comparison-properties';
import {classInstance} from '@/shared/helpers/helpers';

export class ComparisonContent {
	private element: HTMLElement;
	private productsElement: HTMLElement;
	private propertiesElement: HTMLElement;
	private products: ComparisonProducts;
	private properties: ComparisonProperties;

	constructor(element) {
		if (!element) return;
		if (window.app.classInstance.get(element)) window.app.classInstance.get(element).reinit();
		else {
			this.element = element;
			this.productsElement = this.element.querySelector('.js-comparison-products');
			this.propertiesElement = this.element.querySelector('.js-comparison-properties');
			this.init();
		}
	}

	public init = (): void => {
		this.properties = new ComparisonProperties(this.propertiesElement);
		this.products = new ComparisonProducts(this.productsElement, this.properties.slider);
		this.properties.setControl(this.products.slider);
		classInstance.set(this.element, this);
	};

	public destroy = (): void => {
		this.properties.destroy();
		this.properties = null;
		this.products.destroy();
		this.products = null;
		classInstance.del(this, 'SliderProducts');
	};

	public reinit = () => {
		this.destroy();
		this.init();
	};
}
